// extracted by mini-css-extract-plugin
export var freeBox___1YbVz = "PlasmicBanner-module--freeBox___1YbVz--4acf4";
export var freeBox__oeBlb = "PlasmicBanner-module--freeBox__oeBlb--c86b1";
export var root = "PlasmicBanner-module--root--53ae5";
export var span = "PlasmicBanner-module--span--04da7";
export var text___1MWR = "PlasmicBanner-module--text___1MWR--4246c";
export var text__jlBey = "PlasmicBanner-module--text__jlBey--b77c5";